import script from "./LayoutSider.vue?vue&type=script&lang=ts&setup=true"
export * from "./LayoutSider.vue?vue&type=script&lang=ts&setup=true"

import "./LayoutSider.vue?vue&type=style&index=0&id=233c6dcf&lang=less&scoped=true"

import exportComponent from "/root/.jenkins/workspace/test-saas-doctor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-233c6dcf"]])

export default __exports__